import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  Box
} from '@mui/material';
import { Login, Email } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

interface AccountStatusModalProps {
  open: boolean;
  onClose: () => void;
}

const AccountStatusModal: React.FC<AccountStatusModalProps> = ({
  open,
  onClose
}) => {
  const { setShowAuthModal } = useAuth();

  const handleSignIn = () => {
    onClose();
    setShowAuthModal(true, 'signin');
  };

  const handleSignUp = () => {
    onClose();
    setShowAuthModal(true, 'signup');
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      disableRestoreFocus={true}
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
        }
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Email color="primary" sx={{ fontSize: '1.5rem' }} />
          <Typography variant="h6" component="div" sx={{ color: 'primary.main', fontWeight: 600 }}>
            Confirmation Link Expired
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 3 }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            This confirmation link has expired or been used already.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Your account may already be active, or you may need to create a new account.
          </Typography>
        </Alert>

        <Typography variant="body2" sx={{ mb: 2 }}>
          Please choose one of the options below:
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={handleClose}
          sx={{ minWidth: 100 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSignIn}
          variant="contained"
          startIcon={<Login />}
          sx={{ minWidth: 140 }}
        >
          Sign In
        </Button>
        <Button
          onClick={handleSignUp}
          variant="outlined"
          sx={{ minWidth: 140 }}
        >
          Sign Up
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountStatusModal;
